import {
  CONTEXT_TYPE,
  ROA_STATUS,
  ROUTE_OBJECT_STATUS
} from '../../constants/routingStatusConstant';
import requestInstance from '../../utils/requestInstance';

const state = {
  contextType: CONTEXT_TYPE.PREFIXES, //1: prefixes, 2: ans,
  isLoadingData: false,
  isShowMismatchModal: false,
  selectedASN: '',
  currentPage: 1,
  routingStatusObj: {},
  mismatchModalData: {}
};

const getters = {
  routingStatusOfSelectedContext: (state, getters, rootState) => {
    if (state.contextType === CONTEXT_TYPE.ASN) {
      if (!state.selectedASN) return {};

      return state.routingStatusObj[state.selectedASN] || {};
    } else if (state.contextType === CONTEXT_TYPE.PREFIXES) {
      const memberId =
        rootState.dataStore.selectedAccount &&
        rootState.dataStore.selectedAccount.id;
      if (!memberId) return {};

      return state.routingStatusObj[`member_${memberId}`] || {};
    } else {
      return {};
    }
  },

  routeListOfSelectedContext: (state, getters) => {
    if (
      !getters.routingStatusOfSelectedContext ||
      !getters.routingStatusOfSelectedContext.routes
    )
      return [];

    return getters.routingStatusOfSelectedContext.routes;
  },

  roaMismatchListOfSelectedContext: (state, getters) => {
    if (
      !getters.routeListOfSelectedContext ||
      getters.routeListOfSelectedContext.length === 0
    )
      return [];

    return getters.routeListOfSelectedContext.filter(
      item => item.roa_status === ROA_STATUS.MISMATCH
    );
  },

  routeObjectMismatchListOfSelectedContext: (state, getters) => {
    if (
      !getters.routeListOfSelectedContext ||
      getters.routeListOfSelectedContext.length === 0
    )
      return [];

    return getters.routeListOfSelectedContext.filter(
      item => item.route_object_status === ROUTE_OBJECT_STATUS.MISMATCH
    );
  }
};

const actions = {
  fetchRoutingStatusDataOfPrefixes: context => {
    const memberId =
      context.rootState.dataStore.selectedAccount &&
      context.rootState.dataStore.selectedAccount.id;

    if (!memberId) return;

    context.commit('set_contextType', CONTEXT_TYPE.PREFIXES);
    context.commit('set_currentPage', 1);
    context.commit('setIsShowErrorInfoBanner', false, { root: true });

    if (context.state.routingStatusObj[`member_${memberId}`]) return;

    context.commit('set_isLoadingData', true);

    requestInstance
      .get(`/routing-status/${memberId}`)
      .then(res => {
        context.commit('set_routingStatusObj', {
          id: `member_${memberId}`,
          data: res.data
        });
      })
      .catch(err => {
        console.error('fetchRoutingStatusDataOfPrefixes error: ', err);
        context.dispatch('setErrorInfoBanner', '', { root: true });
      })
      .finally(() => {
        context.commit('set_isLoadingData', false);
      });
  },

  fetchRoutingStatusDataOfSelectedASN: (context, { asn, memberId }) => {
    if (!asn.id || !memberId) return;

    context.commit('set_selectedASN', asn.id);
    context.commit('set_contextType', CONTEXT_TYPE.ASN);
    context.commit('set_currentPage', 1);
    context.commit('setIsShowErrorInfoBanner', false, { root: true });

    if (context.state.routingStatusObj[asn.id]) return;

    context.commit('set_isLoadingData', true);

    requestInstance
      .get(`/routing-status/${memberId}/asn/${asn.id}`)
      .then(res => {
        context.commit('set_routingStatusObj', { id: asn.id, data: res.data });
      })
      .catch(err => {
        console.error('fetchRoutingStatusDataOfSelectedASN error: ', err);
        context.dispatch('setErrorInfoBanner', '', { root: true });
      })
      .finally(() => {
        context.commit('set_isLoadingData', false);
      });
  }
};

const mutations = {
  set_contextType: (state, type) => {
    state.contextType = type;
  },

  set_isLoadingData: (state, boolean) => {
    state.isLoadingData = boolean;
  },

  set_selectedASN: (state, value) => {
    state.selectedASN = value;
  },

  set_routingStatusObj: (state, { id, data }) => {
    state.routingStatusObj = { ...state.routingStatusObj, [id]: data };
  },

  set_isShowMismatchModal: (state, boolean) => {
    state.isShowMismatchModal = boolean;
  },

  set_mismatchModalData: (state, payload) => {
    state.mismatchModalData = payload;
  },

  set_currentPage: (state, val) => {
    state.currentPage = val;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
